import { Input } from '@mantine/core';
import classNames from './Input.module.css';

export default Input.extend({
  defaultProps: {
    size: 'md',
  },
  classNames,
});
